module.exports = __webpack_public_path__ + "img/swamp.f37bf986.png";